import { useCallback, useState } from 'react';
import { useParams } from '@direct-frontend/modules-router';
import { useFormInstance } from '@adv-frontend/form-kit';
import { getOrderPayboxPayURL } from '@/entities/digitalOrder';
import { DIGITAL_ORDER_FORM_ID, digitalOrderForm, type OrderPayboxSubmitParams } from '@/features/OrderForm';
import { modalsService } from '@/shared/lib/modalsService';
import { getRequestContext } from '@/shared/lib/requestContext';

interface UseDigitalPayboxSubmitParams {
    orderId: string;
    signature: string;
}

export const useDigitalPayboxSubmit = ({ orderId, signature }: UseDigitalPayboxSubmitParams) => {
    const formInstance = useFormInstance({ form: digitalOrderForm, id: DIGITAL_ORDER_FORM_ID });
    const { storeSlug = '' } = useParams();
    const { company } = getRequestContext();

    const [payboxUrl, setPayboxUrl] = useState('');

    const handlePayboxSubmit = useCallback(
        async (params: OrderPayboxSubmitParams) => {
            try {
                await formInstance.submit();

                if (!company.companyShopUrl) {
                    throw new Error('companyShopUrl must be defined');
                }

                const data = await getOrderPayboxPayURL({
                    order_id: orderId,
                    signature,
                    store_slug: storeSlug,
                    initial_payment_options: JSON.stringify(params.initial_payment_options),
                    on_success_redirect: company.companyShopUrl,
                    on_error_redirect: company.companyShopUrl,
                    on_abort_redirect: company.companyShopUrl,
                });

                setPayboxUrl(data.url);
                modalsService.onPayBoxModal();
            } catch (error) {
                console.error(error);
            }
        },
        [formInstance, orderId, signature, storeSlug, company.companyShopUrl]
    );

    return { handlePayboxSubmit, payboxUrl };
};
